import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll, ScrollToTop } from "@/components/site/Scroll";
import { Layout } from "@/components/site/Layout";

import Home from "@/pages/Home";
import Research from "@/pages/research/Research";
import UPII from "@/pages/research/UPII";
import UEII from "@/pages/research/UEII";
import MemoryProblem from "@/pages/research/MemoryProblem";
import Publications from "@/pages/research/Publications";
import Smritium from "@/pages/Smritium";
import HowItWorks from "@/pages/smritium/HowItWorks";
import Security from "@/pages/smritium/Security";
import Changelog from "@/pages/smritium/Changelog";
import ASOC from "@/pages/products/ASOC";
import Semalayer from "@/pages/products/Semalayer";
import Solutions from "@/pages/solutions/Solutions";
import SolutionDetail from "@/pages/solutions/SolutionDetail";
import Blog from "@/pages/blog/Blog";
import BlogPost from "@/pages/blog/BlogPost";
import About from "@/pages/company/About";
import Careers from "@/pages/company/Careers";
import Contact from "@/pages/company/Contact";
import Patents from "@/pages/company/Patents";
import Press from "@/pages/company/Press";
import ForwardDeployed from "@/pages/company/ForwardDeployed";
import LegalPage from "@/pages/legal/LegalPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />

              <Route path="/research" element={<Research />} />
              <Route path="/research/upii" element={<UPII />} />
              <Route path="/research/ueii" element={<UEII />} />
              <Route path="/research/memory-problem" element={<MemoryProblem />} />
              <Route path="/research/publications" element={<Publications />} />

              <Route path="/smritium" element={<Smritium />} />
              <Route path="/smritium/how-it-works" element={<HowItWorks />} />
              <Route path="/smritium/security" element={<Security />} />
              <Route path="/smritium/changelog" element={<Changelog />} />

              <Route path="/products/asoc" element={<ASOC />} />
              <Route path="/products/semalayer" element={<Semalayer />} />

              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/:slug" element={<SolutionDetail />} />

              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />

              <Route path="/company/about" element={<About />} />
              <Route path="/company/careers" element={<Careers />} />
              <Route path="/company/contact" element={<Contact />} />
              <Route path="/company/patents" element={<Patents />} />
              <Route path="/company/press" element={<Press />} />
              <Route path="/company/forward-deployed" element={<ForwardDeployed />} />

              <Route path="/legal" element={<Navigate to="/legal/terms" replace />} />
              <Route path="/legal/:slug" element={<LegalPage />} />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
